import axios from 'axios';

const axiosApi = axios.create({
    baseURL: 'https://dev.onetapaisolutions.com/api',
});

axiosApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('tk');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosApi;